const socket = {
    'baseUrl': process.env.MIX_SOCKET_URL || 'http://localhost:6001',
    'events': {
        'message': {
            'list': 'message.list',
            'send': 'message.send',
            'sendError': 'message.send.error',
            'receive': 'message.receive',
            'update': 'message.update',
            'delete': 'message.delete',
            'confirm': 'message.confirm',
            'report': 'message.report',
            'reportSuccess': 'message.report.success',
            'reportError': 'message.report.error',
        },
        'room': {
            'init': 'room.init',
            'list': 'room.list',
            //'join': 'room.join',
            //'leave': 'room.leave',
            'update': 'room.update',
            'add': 'room.add',
            'change': 'chat:room.change',
            'checkUnread': 'room.check-unread',
        },
        'auth': {
            'user': 'auth.user',
            'refresh': 'auth.refresh',
            'refreshSuccess': 'auth.refresh.success',
            'refreshError': 'auth.refresh.error',
            'tokenExpired': 'token_expired',
        },
    },
}

export default socket;